"use client"; // This directive marks the component as a Client Component

import Script from "next/script"; // Import the Next.js Script component
import type React from "react";

// Extend Window to include acsbJS
declare global {
  interface Window {
    acsbJS: {
      init: (options: Record<string, unknown>) => void;
    };
  }
}
interface AccessiBeWidgetProps {
  locale: string;
  colorCode?: string;
}

const AccessiBeWidget: React.FC<AccessiBeWidgetProps> = ({
  locale,
  colorCode,
}) => {
  if (process.env.NEXT_PUBLIC_ACCESSIBE_DISABLED === "true") {
    return;
  }

  const isocodes = [
    "en",
    "fr",
    "es",
    "ru",
    "pt",
    "pt_BR",
    "nl",
    "de",
    "ja",
    "tw",
    "zh",
    "he",
    "ar",
    "ua",
    "it",
    "pl",
    "tr",
    "hu",
    "cs",
    "sl",
    "sk",
    "ko",
  ];

  const supportedLocale = isocodes.includes(locale) ? locale : "en";
  const accessWidgetLang = supportedLocale === "pt_BR" ? "pt" : supportedLocale;

  const scriptSrc = `https://acsbapp.com/apps/app/dist/js/app.js?language=${accessWidgetLang}`;

  const handleScriptLoad = () => {
    const config = {
      statementLink: "",
      footerHtml: "",
      hideMobile: false,
      hideTrigger: false,
      disableBgProcess: false,
      language: accessWidgetLang,
      leadColor: `#${colorCode}`,
      interfaceOffsetXposition: 1250,
      triggerColor: `#${colorCode}`,
      triggerRadius: "50%",
      triggerPositionX: "left",
      triggerPositionY: "bottom",
      triggerIcon: "people",
      triggerSize: "medium",
      triggerOffsetX: 20,
      triggerOffsetY: 20,
      mobile: {
        triggerSize: "small",
        triggerPositionX: "right",
        triggerPositionY: "bottom",
        triggerOffsetX: 10,
        triggerOffsetY: 10,
        triggerRadius: "50%",
      },
    };

    if (window.acsbJS) {
      window.acsbJS.init(config);
    } else {
      // Widget not yet loaded, script will initialize it on load
    }
  };

  return (
    <Script
      onError={(_e) => {
        // Script loading errors are non-critical; widget remains optional
      }}
      onLoad={handleScriptLoad}
      src={scriptSrc}
      strategy="afterInteractive"
    />
  );
};

export { AccessiBeWidget };
